<!-- 富信只允许单个上传 -->
<template>
  <div>
    <div class="flex">
      <el-upload
        class="upload"
        :action="actionUrl"
        :accept="acceptStr"
        :before-upload="beforeUpload"
        :on-success="handleUpload"
        :on-error="handleError"
        :on-remove="handleRemove"
        :file-list="fileList"
        :disabled="disabled"
        :data="uploadData"
      >
        <div class="flex">
          <div class="uploadBox displayItem">
            <div class="upload">上传文件</div>
					</div>
          <slot name="custom"></slot>
        </div>
        <!-- <div slot="tip" class="upload_tip">
          只能上传jpg/png/zip文件，且不超过1.4M
        </div> -->
      </el-upload>
    </div>
  </div>
</template>
<script>
// import { mediaFileUpload } from "@/api/smsSend";
export default {
  model: {
    prop: "fileObj",
    event: "changeFile",
  },
  props: {
    size: {
      type: Number,
      default: 1.4,
    },
    // 文件类型
    sorts: {
      type: Array,
      default: function () {
        return [".xlsx"];
      },
    },
    // 文件对象
    fileObj: {
      type: Object,
      default: () => {
        return { name: "", url: "" };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    actionUrl:{
      type: String,
    },
    uploadData:{
      type:Object,
    }
  },
  data() {
    return {};
  },
  computed: {
    acceptStr() {
      return this.sorts.join(",");
    },
    // fileList() {
    //   if (this.fileUrl) {
    //     return [{ name:this.fileName, url: this.fileUrl }];
    //   } else {
    //     return [];
    //   }
    // },
    fileList() {
      if (this.fileObj.url) {
        // console.log(this.fileObj);
        return [{ name: this.fileObj.name, url: this.fileObj.url }];
      } else {
        return [];
      }
    },
  },
  methods: {
    beforeUpload(file) {
      // if(!this.uploadData.platform){
      //   this.$message.warning("请选择平台");
      //   return false;
      // }
      // if(!this.uploadData.channelSellerManageId){
      //   this.$message.warning("请选择店铺");
      //   return false;
      // }
      console.log(file);
      if (file.size > this.size * 1024 * 1024) {
        this.$message.warning(
          "所选文件大小不得超过" + this.size + "M，请重新选择"
        );
        return false;
      }
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      console.log(type, this.sorts.indexOf(type));
      if (this.sorts.indexOf(type) < 0) {
        this.$message.warning("所选文件格式不符，请重新选择");
        return false;
      }
      // let forms = new FormData();
      // forms.append("file", file);
      // mediaFileUpload(this.type, forms).then((res) => {
      //   this.$message.success("上传成功");
      //   let { mulitiFileName, fileUrl } = res.data;
      //   this.$emit("changeFile", { name: mulitiFileName, url: fileUrl });
      //   this.$emit("success", res.data);
      // });
      // return false;
    },

    // 上传成功
    handleUpload(res, file, fileList) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.$message.success("上传成功");
        let { mulitiFileName, fileUrl } = res.data;
        this.$emit("changeFile", { name: mulitiFileName, url: fileUrl });
        this.$emit("success", res.data);
      }
    },
    // 上传失败
    handleError(err) {
      console.log(err);
      this.$message.error("上传失败");
    },

    // 移除文件
    handleRemove(file, fileList) {
      console.log(file, fileList);
      if (fileList.length > 0) {
        // let fileObj = fileList[0]
        // this.$emit("changeFile", { name: fileObj.name, url: fileObj.url });
        // this.$emit("success", {});
      } else {
        this.$emit("changeFile", { name: "", url: "" });
        this.$emit("success", {});
      }
    },

    // 后面这些暂时不需要
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-upload-list__item {
  transition: none !important;
}

.flex {
  display: flex;
  align-items: center;
}
/deep/.upload_tip {
  margin: 8px 0;
  color: #999999;
  line-height: 12px;
  font-size: 12px;
}

.uploadBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .upload {
    box-sizing: border-box;
    width: 186px;
		height: 32px;
		background: #ECF0F8;
		border-radius: 6px 6px 6px 6px;
		opacity: 1;
		border: 1px solid #7489B5;
    transition: all .1s;
		font-size: 14px;
		font-weight: 400;
		color: #1F4287;
		text-align: center;
    &:hover {border-color: #5882FB;}
		}
		.info{
        font-size: 12px;
				font-weight: 400;
				color: #999999;
				line-height: 21px;
    }
		.downBtn{
			margin: 0 16px;
			font-size: 14px;
			font-weight: 400;
			color: #1F4287;
			line-height: 21px;
			cursor: pointer;
		}
}

.upload {
  // margin-bottom: 10px;
  display: inline-block;

  .el-button {
    background-color: #fff6f6 !important;
    border: 1px solid #fe4d45 !important;
    color: #fe4d45 !important;

    &:hover {
      background-color: #ffe5e5 !important;
    }

    &:active {
      background-color: #fff4f4 !important;
    }
  }

  img {
    width: 15px;
    margin-right: 2px;
    position: relative;
    top: 2px;
  }
}
</style>
